import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { WhoThisIsFor } from './components/WhoThisIsFor';
import { WhyLimaDental } from './components/WhyLimaDental';
import { BeforeAfter } from './components/BeforeAfter';
import { OfferSection } from './components/OfferSection';
import { ThreeSteps } from './components/ThreeSteps';
import { DoctorTrust } from './components/DoctorTrust';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { FormModalProvider } from './components/FormModal';
export function App() {
  useEffect(() => {
    document.title = 'Lima Dental';
  }, []);
  return <FormModalProvider data-id="element-0">
      <div className="min-h-screen bg-brand-dark font-inter selection:bg-white/20 pb-20 lg:pb-0" data-id="element-1">
        {/* Header / Logo Area */}
        <header className="bg-brand-dark/95 backdrop-blur py-2.5 lg:py-4 px-4 sm:px-6 lg:px-8 border-b border-white/10 sticky top-0 z-40" data-id="element-2">
          <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-3">
            <div className="flex items-center gap-2" data-id="element-4">
              <img src="https://cdn.magicpatterns.com/uploads/6ZFaZaYmrHuUkbBuoBaq9o/LOGO2.png" alt="Lima Dental Group" className="h-4" data-id="element-5" />
            </div>
            <div className="hidden md:block text-sm font-medium text-white/50" data-id="element-6">
              Miami Lakes, FL
            </div>
          </div>
        </header>

        <main data-id="element-7">
          <Hero data-id="element-8" />
          <TrustStrip data-id="element-9" />
          <WhoThisIsFor data-id="element-10" />
          <WhyLimaDental data-id="element-11" />
          <BeforeAfter data-id="element-12" />
          <OfferSection data-id="element-13" />
          <ThreeSteps data-id="element-14" />
          <DoctorTrust data-id="element-15" />
          <FAQ data-id="element-16" />
          <FinalCTA data-id="element-17" />
        </main>

        {/* Footer */}
        <footer className="bg-brand-dark text-white/40 py-5 lg:py-8 text-center text-sm border-t border-white/10" data-id="element-18">
          <div className="max-w-7xl mx-auto px-4" data-id="element-19">
            <p data-id="element-20">
              © {new Date().getFullYear()} Lima Dental Group. All rights
              reserved.
            </p>
            <p className="mt-2 text-xs" data-id="element-21">
              This site is not a part of the Facebook website or Facebook Inc.
              Additionally, This site is NOT endorsed by Facebook in any way.
              FACEBOOK is a trademark of FACEBOOK, Inc.
            </p>
          </div>
        </footer>

        <StickyMobileCTA data-id="element-22" />
      </div>
    </FormModalProvider>;
}